export enum AppServiceStatusEnum {
  ACTIVE = 0,
  DISABLED = 1,
  HIDDEN = 2,
  NO_ACTION = 3,
}
